import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const EnrollRedux = createActions(
  {
    enrollRequest: ['studentId', 'data'],
    enrollSuccess: ['data'],
    enrollFailure: ['errors'],
    deleteEnrollRequest: ['studentId', 'data'],
    deleteEnrollSuccess: ['data'],
    deleteEnrollFailure: ['errors'],
    resetError: [],
  },
  {
    prefix: 'ENROLL_',
    defaultActions: {
    },
  },
)

const { Types, Creators } = EnrollRedux
export const EnrollTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
}, {
})

/* ------------- Reducers ------------- */
const resetError = state => state.merge({ create: { fetching: false, error: null } }, d)

const enrollRequest = state => state.merge({
  sending: {
    fetching: true,
    error: null,
  },
  new_enroll: {
    error: '',
    success: false,
  },
}, d)

const enrollSuccess = (state, { data }) => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
  new_enroll: {
    error: '',
    success: true,
  },
  ...data,
}, d)

const enrollFailure = (state, { errors }) => state.merge({
  sending: {
    fetching: false,
    error: errors,
  },
  new_enroll: {
    success: false,
    error: errors[0],
  },
}, d)

const deleteEnrollRequest = state => state.merge({
  sending: {
    fetching: true,
    error: null,
  },
  delete_enroll: {
    error: '',
    success: false,
  },
}, d)

const deleteEnrollSuccess = (state, { data }) => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
  delete_enroll: {
    error: '',
    success: true,
  },
  ...data,
}, d)

const deleteEnrollFailure = (state, { errors }) => state.merge({
  sending: {
    fetching: false,
    error: errors,
  },
  delete_enroll: {
    success: false,
    error: errors[0],
  },
}, d)


export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.enrollRequest]: enrollRequest,
    [Types.enrollSuccess]: enrollSuccess,
    [Types.enrollFailure]: enrollFailure,
    [Types.deleteEnrollRequest]: deleteEnrollRequest,
    [Types.deleteEnrollSuccess]: deleteEnrollSuccess,
    [Types.deleteEnrollFailure]: deleteEnrollFailure,
    [Types.resetError]: resetError,
  },
  {
    defaultActions: {
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/EnrollRedux.js